export default __webpack_public_path__ + "static/venue-2-f3d48993b5569ad348a53f14b7ae225b.jpg";